export enum OptionFormatTypes {
	RAW = 'raw',
	LIST = 'list',
	TABLE = 'table',
}
